module.exports = __webpack_public_path__ + "img/banner-1.21311b73.jpg";